import React from 'react';

import { useIntl } from 'react-intl-next';

import Button from '@atlaskit/button';

import messages from './messages';
import { PaginationDetails } from './pagination-details';
import { StyledFooter } from './styled';
import { type FooterProps } from './types';

export const Footer: React.FC<FooterProps> = ({
	isFullList,
	hasValue,
	onClear,
	onFullList,
	itemCount,
	totalCount,
	isLoading,
	isError,
	searchThreshold = 5,
}) => {
	const { formatMessage } = useIntl();

	if (isLoading || isError) {
		return null;
	}

	const shouldShowPagination =
		itemCount && totalCount && (totalCount <= searchThreshold || isFullList);

	const shouldShowFooter =
		(hasValue && onClear) ||
		(!hasValue && !isFullList && onFullList && itemCount) ||
		shouldShowPagination;

	if (!shouldShowFooter) {
		return null;
	}

	return (
		<StyledFooter data-testid="footer">
			{hasValue && onClear && (
				<Button
					onClick={onClear}
					// TODO: (from codemod) "link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
					// https://product-fabric.atlassian.net/browse/DSP-19035
					appearance="subtle-link"
				>
					{formatMessage(messages.clearSelection)}
				</Button>
			)}
			{!hasValue && !isFullList && onFullList && itemCount && (
				<Button
					onClick={onFullList}
					// TODO: (from codemod) "link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
					// https://product-fabric.atlassian.net/browse/DSP-19035
					appearance="subtle-link"
				>
					{formatMessage(messages.showFullList)}
				</Button>
			)}
			{shouldShowPagination ? (
				<PaginationDetails itemsCount={itemCount} totalCount={totalCount} />
			) : (
				''
			)}
		</StyledFooter>
	);
};
